import { AutoplayServiceEvent, IServices } from "@netent/origin";
import { IPlayUIState, View } from "@netent/playui";
import { ListenerCreator } from "../../types";

const closed = (services: IServices) => (): IPlayUIState => ({
  view: View.DEFAULT,
  autoplay: {
    rounds: {
      selected: services.autoplay.getRemaining() || null
    }
  }
});

const opened = () => (): IPlayUIState => ({
  view: View.AUTOPLAY_SETTINGS
});

const roundsChanged = () => (roundsLeft: number): IPlayUIState => ({
  autoplay: {
    rounds: {
      selected: roundsLeft,
      left: roundsLeft
    }
  }
});

const roundStarted = () => (roundsLeft: number): IPlayUIState => ({
  autoplay: {
    rounds: {
      left: roundsLeft
    }
  },
  menu: {
    enabled: false
  }
});

const started = () => (): IPlayUIState => ({
  autoplay: {
    running: true
  }
});

const stopped: ListenerCreator = (services: IServices) => (): IPlayUIState => ({
  autoplay: {
    enabled:
      !services.gameRound.isRoundActive() && services.autoplay.isEnabled(),
    running: false,
    settings: services.autoplay.getStopConditions(),
    rounds: {
      selected: null,
      left: 0
    }
  },
  bet: {
    enabled:
      !services.freeRounds.isActive() && !services.gameRound.isRoundActive()
  },
  menu: {
    enabled: !services.gameRound.isRoundActive()
  }
});

const stopConditionAdded = (services: IServices) => (): IPlayUIState =>
  services.autoplay.isAvailable()
    ? {
        autoplay: {
          settings: services.autoplay.getStopConditions()
        }
      }
    : {
        autoplay: null
      };

const stopConditionChanged = (services: IServices) => (): IPlayUIState =>
  services.autoplay.isAvailable()
    ? {
        autoplay: {
          settings: services.autoplay.getStopConditions()
        }
      }
    : {
        autoplay: null
      };

const enabled = (sevices: IServices) => (): IPlayUIState => ({
  autoplay: {
    enabled: sevices.autoplay.isEnabled()
  }
});

export const listeners = new Map<AutoplayServiceEvent, ListenerCreator>([
  ["opened", opened],
  ["closed", closed],
  ["roundsChanged", roundsChanged],
  ["roundStarted", roundStarted],
  ["started", started],
  ["stopped", stopped],
  ["stopConditionAdded", stopConditionAdded],
  ["stopConditionChanged", stopConditionChanged],
  ["enabled", enabled],
  ["disabled", enabled]
]);
